module.exports = __webpack_public_path__ + "static/media/ic-logout.6edbc247.svg";